export default __webpack_public_path__ + "static/media/InfinitiBG.42b35408.png";